import React from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'

import queryGraphql from '@shared/components/queryGraphql'
import { checkRedirectionStatus, currentDateMonth, getTimeZone, handleApiError } from '@shared-submodule/utils'
import { GET_SEO_DATA } from '@graphql/article/article.query'
import { GET_CATEGORY_BY_ID } from '@graphql/category/category.query'
import { CURRENT_SERIES_LIST, RANKINGS } from '@graphql/globalwidget/rankings.query'
const FantasyTipsList = dynamic(() => import('@shared/components/fantasyTips/fantasyTipsList'))

function FantasyTips({ seoData, category, currentSeriesData, rankingTabData, seriesList }) {
  return (
    <FantasyTipsList seoData={seoData} category={category} currentSeriesData={currentSeriesData} rankingTabData={rankingTabData} />
  )
}

FantasyTips.propTypes = {
  fantasyTipsList: PropTypes.array,
  seriesList: PropTypes.array,
  seoData: PropTypes.object,
  category: PropTypes.object,
  currentSeriesData: PropTypes.object,
  rankingTabData: PropTypes.object
}

export default FantasyTips

export async function getServerSideProps({ req, res, query, resolvedUrl }) {
  try {
    res.setHeader('Cache-Control', 'public, max-age=10')
    const { allRoutes } = (await import('@shared-submodule/sm-constants/allRoutes'))
    const { data: seoData } = await queryGraphql(GET_SEO_DATA, { input: { sSlug: allRoutes.fantasyCricketTips.replaceAll('/', '') } })

    // Check Redirection
    const { redirectStatus, eCode, returnObj, props } = checkRedirectionStatus(seoData?.getSeoData)
    if (redirectStatus && props) {
      res.statusCode = eCode
      return { props }
    } else if (redirectStatus) return returnObj
    const { data: category } = await queryGraphql(GET_CATEGORY_BY_ID, { input: { _id: '640f04636a4725ab9560b7d3' } })

    const { data: currentSeriesData } = await queryGraphql(CURRENT_SERIES_LIST)
    const { data: rankingTabData } = await queryGraphql(RANKINGS, { input: { eMatchType: 'Tests', eRankType: 'Teams', nLimit: 5, nSkip: 0 } })
    return {
      props: {
        seoData: seoData?.getSeoData || {},
        category: category?.getCategoryByIdFront || {},
        currentSeriesData: currentSeriesData || {},
        rankingTabData: rankingTabData || {},
        timezone: { timezone: getTimeZone(), date: currentDateMonth() } || {}
      }
    }
  } catch (e) {
    console.log(e)
    res.setHeader('Cache-Control', 'no-cache')
    const status = handleApiError(e, resolvedUrl)
    return status
  }
}
